module.exports = __webpack_public_path__ + "static/media/panda@2x.d10939ae.png";